import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["parentCheckbox", "dependentCheckbox"]

  connect() {
    if(this.parentCheckboxTarget.checked) {
      this.checkAndDisableDependents()
    }
  }

  updateDependentCheckboxState() {
    if(this.parentCheckboxTarget.checked) {
      this.checkAndDisableDependents()
    } else {
      this.uncheckAndEnableDependents()
    }
  }

  checkAndDisableDependents() {
    this.dependentCheckboxTargets.map((dependent) => {
      dependent.checked = true
      dependent.disabled = true
    })
    this.mdlUpgradeCheckboxes()
  }

  uncheckAndEnableDependents() {
    this.dependentCheckboxTargets.map((dependent) => {
      dependent.checked = false
      dependent.disabled = false
    })
    this.mdlUpgradeCheckboxes()
  }

  // Required to visually change the state of MDL checkboxes
  mdlUpgradeCheckboxes() {
    const evt = new Event("change")
    this.dependentCheckboxTargets.map(dependent => dependent.dispatchEvent(evt))
  }

}
